export function initSiteSearchActions(context) {
  const siteSearchShowFiltersButton = once(
    'siteSearchShowFiltersButton',
    '#site-search-show-filters-button',
    context
  )[0];

  const siteSearchHideFiltersButton = once(
    'siteSearchHideFiltersButton',
    '#site-search-hide-filters-button',
    context
  )[0];

  const searchFilters = once(
    'searchFilters',
    '#site-search-filters',
    context
  )[0];

  const searchApplyFilterButton = once(
    'searchApplyFilterButton',
    '#apply-filters-submit-button',
    context
  )[0];

  siteSearchShowFiltersButton?.addEventListener('click', function (e) {
    searchFilters.setAttribute('data-show', 'true');
  });
  siteSearchHideFiltersButton?.addEventListener('click', function (e) {
    searchFilters.setAttribute('data-show', 'false');
  });

  searchFilters?.querySelectorAll('input').forEach(input => {
    input.addEventListener('change', function (e) {
      searchApplyFilterButton.disabled = false;
    });
  });
}
